import { observer } from "mobx-react";
import React from "react";
import { EditInputFieldState } from "@fidget/common/components/form/editInput";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { onEnter as onEnterListener } from "@fidget/common/utils/domHelper";
import styles from "../../tagsSettings.css";
import { NewTagFormType } from "../../types";
import { staticConfig } from "@fidget/common/config/static-config";

interface Props {
  form: NewTagFormType;
  onEnter(): void;
}
export const NewTagBox = observer(({ form, onEnter }: Props) => {
  return (
    <div className={styles["new-form-container"]}>
      <EditInputFieldState
        {...onEnterListener(onEnter)}
        className={styles["text-input"]}
        field={form.$.tag}
        placeholder={intl.formatMessage("settings.tags.placeholder")}
        maxLength={staticConfig.tagNameMaxCharacters}
      />
      <p className={styles["add-new-description"]}>
        {intl.formatMessage("settings.tags.addNew.description", {
          limit: staticConfig.tagNameMaxCharacters
        })}
      </p>
    </div>
  );
});
